const isArrivedFromWebview = () => {
  return window.isInsideWebView;
};

export default isArrivedFromWebview;
